<template>
  <div class="h-100">
    <el-container class="container">
      <el-header height="61px">
        <navbar></navbar>
      </el-header>
    </el-container>
    <el-container class="content">
      <el-main class="container">
      <div v-if="idConfigClienteApp">
      <seleciona-aplicacao
        v-on:aplicacao-selecionada="onSelect"
        :default-selected="idConfigClienteApp"
      ></seleciona-aplicacao>
      <br>
      <embed-omnichannel-s-d-k
        :key="countEmbed"
        :url="url"
        :json="json"
      ></embed-omnichannel-s-d-k>
    </div>
    <div v-else>
      <seleciona-aplicacao
          :key="countSelect"
          v-on:aplicacao-selecionada="onSelect"
          :type="'lista'"
      ></seleciona-aplicacao>
    </div>
    </el-main>
    </el-container>
    <el-container class="footer">
      <el-footer height="110px" class="container">
        <omni-footer></omni-footer>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import EmbedOmnichannelSDK from '@/components/shared/embed-omnichannel-sdk/EmbedOmnichannelSDK'
import { mapState } from 'vuex'
import SelecionaAplicacao from '@/components/shared/seleciona-aplicacao/SelecionaAplicacao'
import Navbar from '@/components/shared/navbar/navbar-configuracoes/Navbar.vue'
import OmniFooter from '@/components/shared/footer/OmniFooter.vue'
export default {
  name: 'MensageriaAplicacao',
  components: {
    SelecionaAplicacao,
    EmbedOmnichannelSDK,
    Navbar,
    OmniFooter
  },
  props: {
    idConfigClienteApp: {
      required: false
    }
  },
  computed: {
    ...mapState('login', ['token']),
    json () {
      return {
        path: `configurador-aplicacao/${this.idConfigClienteApp}`,
        authorization: this.token
      }
    }
  },
  data () {
    return {
      internalLoading: false,
      aplicacao: null,
      embedArea: null,
      countEmbed: 0,
      url: process.env.VUE_APP_URL_CONFIGURADOR_PUBLICO_FRONT,
      countSelect: 0
    }
  },
  methods: {
    onSelect (data) {
      this.countEmbed += 1
      window.location.href = `${process.env.VUE_APP_MENSAGERIA_URL}?token=${this.token}&id_config_cliente_app=${data}`
    }
  },
  mounted () {
    this.countSelect += 1
  }
}
</script>
